module.exports = __webpack_public_path__ + "static/img/logo.3b8bf57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/logo.svg
// module id = EjJY
// module chunks = 0